import * as React                    from 'react'
import { FormattedMessage }          from 'react-intl'
import { connect }                   from 'react-redux'
import { Link, RouteComponentProps } from 'react-router-dom'

import Button                              from '@material-ui/core/Button/Button'
import Card                                from '@material-ui/core/Card/Card'
import CardActions                         from '@material-ui/core/CardActions/CardActions'
import CardContent                         from '@material-ui/core/CardContent/CardContent'
import CardHeader                          from '@material-ui/core/CardHeader/CardHeader'
import { InjectedFormikProps, withFormik } from 'formik'
import { object }                          from 'yup'

import { ApplicationState, forgotPasswordRequest }                      from '../../redux'
import { ActionButton, EnhancedTextField, InlineError, LoadingOverlay } from '../atoms/index'
import { i18nErrorCodes, mapFormikToMuiProps }                          from '../forms/form-utils'
import { emailSchema }                                                  from '../forms/schemas/formatSchemas'

const mstp = (state: ApplicationState) =>
  ({
    forgotPasswordCommunication: forgotPasswordRequest.communicationSelector(state),
  })

const actions = { forgotPassword: forgotPasswordRequest.actionCreator }

type ReduxProps =
  ReturnType<typeof mstp>
  & typeof actions

type PassedProps =
  ReduxProps
  & RouteComponentProps<{ token: string }>

interface ForgotPasswordFields {
  email: string
}

type Props = InjectedFormikProps<PassedProps, ForgotPasswordFields>

class ForgotPassword extends React.Component<Props> {
  public componentDidUpdate (lastProps: Props) {
    if (
      lastProps.forgotPasswordCommunication.fetching
      && this.props.forgotPasswordCommunication.success
    ) {
      const { history } = this.props

      history.replace('/forgot-password-sent')
    }
  }

  public render () {
    const phrasing = {
      passwordRecovery:     <FormattedMessage id={'forms.passwordRecovery'} />,
      forgotPasswordPrompt: <FormattedMessage id={'forms.forgotPasswordPrompt'} />,
    }

    const mapper = mapFormikToMuiProps(this.props as any)

    const { forgotPasswordCommunication: { error, fetching } } = this.props

    return (
      <Card>
        <LoadingOverlay show={fetching}>
          <CardHeader
            title={phrasing.passwordRecovery}
            subheader={phrasing.forgotPasswordPrompt}
          />
          <form onSubmit={this.props.handleSubmit}>
            <CardContent>
              <EnhancedTextField
                autoFocus
                fullWidth
                {...mapper('email')}
              />
            </CardContent>
            {error && (
              <CardContent>
                <InlineError i18nErrorId={error} />
              </CardContent>
            )}
            <CardActions>
              <ActionButton
                variant={'raised'}
                type={'submit'}
                actionType={'submit'}
                color={'primary'}
              />
              <Link to={''}>
                <Button color={'primary'}>
                  <FormattedMessage id={'buttonActions.backToLogin'} />
                </Button>
              </Link>
            </CardActions>
          </form>
        </LoadingOverlay>
      </Card>
    )
  }
}

export default connect(mstp, actions)(withFormik<PassedProps, ForgotPasswordFields>({
  validationSchema: object().shape({ email: emailSchema.required(i18nErrorCodes.required) }),
  mapPropsToValues: () => ({ email: '' }),
  handleSubmit:     (values, bag) => {
    bag.props.forgotPassword(values)
  },
})(ForgotPassword))



// WEBPACK FOOTER //
// ./src/components/organisms/ForgotPassword.tsx